<template>
	<header>
		<div class="l-content" style="position: relative;z-index: 999">
			<!-- <el-button plain icon="el-icon-menu" size="mini" @click="collapseMenu"></el-button> -->
			<div>
			<i class="icons" :class="[active ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right']" size="mini" @click="collapseMenu" style=""></i>
			</div>
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<!--很明显 首页 一定是存在的 所以这里直接写死-->
				<el-breadcrumb-item :to="{ path: '/home' }" ><span style="color: #FFF0FF;">{{this.$t('getapi[7975]')}}</span></el-breadcrumb-item>
				<!--第二级菜单名称 就要看左侧组件有没有点击指定菜单，没有那就只显示首页 点击就显示当前菜单名称-->
				<el-breadcrumb-item :to="current.path" v-if="current"><span style="color: #FFF0FF;">{{ current.label }}</span></el-breadcrumb-item>
			</el-breadcrumb>
			<el-dropdown @command="handleCommand">
				<span class="el-dropdown-link" style="color: #FFF0FF; margin-left: 20px;cursor: pointer;">
					{{expLanguage(language)}}
					<i class="el-icon-arrow-down el-icon--right"></i>
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item :disabled="language === 'zh'" command="zh">中文</el-dropdown-item>
					<el-dropdown-item :disabled="language === 'en'" command="en">English</el-dropdown-item>
					<el-dropdown-item :disabled="language === 'id'" command="id">id</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>

			<el-dropdown @command="handleCommandDB" v-if="ismultipleDB == 1">
				<span class="el-dropdown-link" style="color: #FFF0FF; margin-left: 20px;cursor: pointer;">
									{{dbname}}

					<i class="el-icon-arrow-down el-icon--right"></i>
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item
							v-for="(item,index) in dbarr"
							:key="index"
							:command="handleDB(item.Login_DB,item.Login_Group,item.Login_DB_View,item.User_Login_Code,item.User_Login_Pwd)">{{item.Login_DB_View}}</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>

		<div class="r-content" style="position: relative;z-index: 999">
			<el-dropdown trigger="click" size="mini">
				<span class="el-dropdown-link">
					<!-- <span class="username">数据库:{{user.Login_DB}}</span> -->
					<img :src="userImg" class="user" :style="{background:GLOBAL.newversion == 0?'orange':'none'}"/>
						<el-badge :value="$root.MyMsg" class="item" v-if="$root.MyMsg > 0">
							<span class="username">{{ user.username }}</span>
						</el-badge>
						<span v-if="$root.MyMsg == 0" class="username">{{user.username}}</span>
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item @click.native="personalWorkspace">{{this.$t("getapi[10]")}}</el-dropdown-item>
					<el-dropdown-item @click.native="changePwd">{{this.$t("getapi[1129]")}}</el-dropdown-item>
					<el-dropdown-item @click.native="updateMDB">{{this.$t("getapi[12487]")}}</el-dropdown-item>
					<el-dropdown-item @click.native="updatehistory">{{this.$t("getapi[6569]")}}</el-dropdown-item>
					<el-dropdown-item @click.native="meetingroom" v-if="user.Login_DB=='JM'">{{$t("getapi[13294]")}}</el-dropdown-item>
					<el-dropdown-item @click.native="meetingroomlist" v-if="user.Login_DB=='JM'">{{$t("getapi[13295]")}}</el-dropdown-item>
					<el-dropdown-item @click.native="logOut">{{this.$t("getapi[32]")}}</el-dropdown-item>
					<el-dropdown-item @click.native="versionUpdate" v-if="GLOBAL.newversion == 0">{{this.$t("getapi[12759]")}}{{localStorage.getItem('version')}}</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
		<changepwd :isVisible="false" ref="changepwd"></changepwd>
	</header>
</template>

<script>
import { mapState,mapMutations } from 'vuex';
import Common from '@/components/Common';
import axios from 'axios';
import { encryptDes, decryptDes,generatekey } from '@/utils/des.js'
export default {
	computed: {
		...mapState({
			current: state => state.tab.currentMenu
		})
	},
	data() {
		return {
			language: window.localStorage.getItem('lang'),
			active: true,
			userImg: require('../assets/img/login/logs.jpg'),
			user: {},
			dbname: '',
			dbarr:[],
            ismultipleDB: 0,
		};
	},
	mounted: function() {
        if (!sessionStorage.getItem('userData')) {
            this.$router.push({path: '/'})
        }
		var users = sessionStorage.getItem('userData');
		users = JSON.parse(users);
		this.user = users;
		let dbinfo = JSON.parse(sessionStorage.getItem('dbinfo'))
        this.dbarr = dbinfo.DBinfo
        this.dbname = users.Login_Instance
		this.ismultipleDB = dbinfo.ismultipleDB
	},
	methods: {
        ...mapMutations({
            closeAll: 'closeAll',
        }),
		// 根据下拉框的中被选中的值切换语言
		handleCommand(key) {
			this.language = key;
			this.$i18n.locale = key; //
			window.localStorage.setItem('lang', this.language);
		},
        handleDB(Login_DB,Login_Group,Login_DB_View,Login_Code,Login_Pwd){
          	  return {
                  Login_DB:Login_DB,
                  Login_Group:Login_Group,
                  Login_DB_View:Login_DB_View,
                  Login_Code:Login_Code,
                  Login_Pwd:Login_Pwd,
			  }
		},
		//切换数据库
		handleCommandDB(info){
            let that = this
            that.$http.urlpost('User/SYS_Users/LoginOut', null, function(res) {
                if (res.Success == 1) {
                    const key = generatekey(8);
                    let data = {
                        SysName: 'ERP',
                        Login_DB: info.Login_DB,
                        Login_Group: info.Login_Group,
                        Login_DB_View: info.Login_DB_View,
                        Login_Code: info.Login_Code,
                        Login_Pwd: info.Login_Pwd,
                        LangType: that.$processdata.getLang(),
                        IP_Address: window.location.hostname
                    };
                    axios
                        .post(Common.Url + 'User/SYS_Users/Login', data)
                        .then(function (res) {
                            let reqdata = res.data;
                            if (reqdata.Success == 1 || reqdata.Success == 2) {
                                // console.log("登录返回数据:"+reqdata.Msg);
                                let userdata = {
                                    username: reqdata.Login_Name,
                                    plv1: reqdata.P_LV1,
                                    plv2: reqdata.P_LV2,
                                    plv3: reqdata.P_LV3,
                                    plv4: reqdata.P_LV4,
                                    token: reqdata.Token,
                                    Login_DB: info.Login_DB,
                                    Login_Group: info.Login_Group,
                                    Login_Code: info.Login_Code,
                                    Login_Pwd: that.userpwd,
                                    Company_Name: reqdata.Company_Name,
                                    Login_Instance: reqdata.Login_Instance,
                                    inner_flag: reqdata.inner_flag,
                                    EmpCode: reqdata.EmpCode,
                                };
                                sessionStorage.setItem('userData', JSON.stringify(userdata));
                                if(reqdata.P_LV2.substr(577 - 1, 1) == 2){
                                    if(reqdata.MList){
                                        for(let i = 0;i<reqdata.MList.length;i++){
                                            reqdata.MList[i].User_Login_Pwd = encryptDes(reqdata.MList[i].User_Login_Pwd, key)
                                        }
                                        sessionStorage.setItem('dbinfo', JSON.stringify({
                                            ismultipleDB: 1,
                                            DBinfo:reqdata.MList
                                        }))
                                    }
                                } else {
                                    sessionStorage.setItem('dbinfo', JSON.stringify({
                                        ismultipleDB: 0,
                                        DBinfo:[]
                                    }))
                                }
                                location.reload()
                            }
                            else{
                                //that.$message.warning(this.$t("getapi[12491]"))
                                that.$message.warning(that.$processdata.explainCallbackMsg(reqdata.Msg));
							}
                        })
                        .catch(function (error) {
                            that.$message.error('错误提示: ' + error);
                            that.btns = false;
                        });
                }
            });
		},
		//控制左侧菜单是否折叠
		collapseMenu() {
			if (this.active) {
				this.active = false;
                document.getElementById("silderLeft").style.width = 65 + 'px'
			} else {
				this.active = true;
                document.getElementById("silderLeft").style.width = 240 + 'px'
			}
			this.$store.commit('collapseMenu');
		},
		//退出登陆
		logOut() {
			let that = this;
			that.closeAll()
			that.$http.urlpost('User/SYS_Users/LoginOut', null, function(res) {
				if (res.Success == 1) {
                    sessionStorage.removeItem('userData')
					that.$router.push({ path: '/' });
					that.$store.dispatch('/logout');
				}
			});
		},
		//更新历史
		updatehistory() {
			let that = this
            that.$store.commit('setSharedParams',{
                    id: that.PartId
				});
                let item = {
                    label: '系统升级历史',
                    name: 'updatehistory',
                    path: '/updatehistory',
                    url: '/updatehistory',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/updatehistory'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
		},
		meetingroom(){
            let that = this
            let item = {
                label: that.$t("getapi[13294]"),
                name: 'meetingroom',
                path: '/meetingroom',
                url: '/meetingroom',
                icon: 'video-play'
            };
            this.$router.push({ path: '/meetingroom'});
            this.$store.commit('selectMenu', item);
            this.$limits.cachePage(item)
		},
        meetingroomlist(){
            let that = this
            let item = {
                label: that.$t("getapi[13295]"),
                name: 'meetingroomlist',
                path: '/meetingroomlist',
                url: '/meetingroomlist',
                icon: 'video-play'
            };
            this.$router.push({ path: '/meetingroomlist'});
            this.$store.commit('selectMenu', item);
            this.$limits.cachePage(item)
        },
        //多库登陆信息
        updateMDB() {
            let that = this
            let item = {
                label: this.$t('getapi[12487]'),
                name: 'multipledb',
                path: '/multipledb',
                url: '/multipledb',
                icon: 'video-play'
            };
            this.$router.push({ path: '/multipledb'});
            this.$store.commit('selectMenu', item);
            this.$limits.cachePage(item)
        },
		// 修改密码
        changePwd(){
            let that = this;
            that.$refs.changepwd.clearInput(true)
		},
		//个人工作区
        personalWorkspace(){
            let that = this
            let item = {
                label: this.$t('getapi[10]'),
                name: 'personalworkspace',
                path: '/personalworkspace',
                url: '/personalworkspace',
                icon: 'video-play'
            };
            this.$router.push({ path: '/personalworkspace'});
            this.$store.commit('selectMenu', item);
            this.$limits.cachePage(item)
		},
        expLanguage(val){
            if(val == 'zh'){
                return '中文'
			} else if(val == 'en'){
                return 'English'
			} else if(val == 'id'){
                return 'id'
			} else {
                return '中文'
			}
		},
        versionUpdate(){
            axios.get(`static/version.json`).then(res => {
                localStorage.setItem('version', res.data.version);
            });
            window.location.reload();
		},
	}
};
</script>

<style lang="scss" scoped>
header {
	display: flex;
	height: 100%;
	align-items: center;
	justify-content: space-between;
}
span.username {
	color: #fff;
	display: inline-block;
	max-width:3em;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	line-height: 43px;
	margin: 0 5px;
}

span.el-dropdown-link.el-dropdown-selfdefine {
	display: flex;
}
.icons {
	color: #fff;
	display: inline-block;
	font-size: x-large;
	margin-left: -20px;
	margin-right: 10px;
}
.l-content {
	display: flex;
	align-items: center;

	.el-button {
		margin-right: 20px;
	}
}

.r-content {
	.user {
		width: 40px;
		height: 40px;
		border-radius: 50%;
	}
}
.el-breadcrumb__inner a,.el-breadcrumb__inner span, .el-breadcrumb__inner.is-link {
    color: #ffffff !important;
}
.el-breadcrumb__item {
	.el-breadcrumb__inner {
		color: #ffffff !important;
		font-weight: normal;
	}

	&:last-child {
		.el-breadcrumb__inner {
			color: #ffffff !important;
		}
	}
}
</style>
